import { MODAL_TYPES } from "../config/MODAL_TYPES";
import MenuFormModal from "./MenuFormModal";

const ModalManager = ({ modal, onClose, refresh, showToast, proveedores }) => {
  if (!modal) return null;

  switch (modal.type) {
    case MODAL_TYPES.FORM:
      return (
        <MenuFormModal
          open
          onClose={onClose}
          menu={modal.menu}
          proveedores={proveedores}
          refresh={refresh}
          showToast={showToast}
        />
      );

    default:
      return null;
  }
};

export default ModalManager;
